import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';

export enum EditableStandardEntityName {
  company = 'company',
  contract = 'contract',
  location = 'location',
  level = 'level',
  user = 'user',
  organization = 'organization',
}

export const editableStandardEntityNames = Object.values(
  EditableStandardEntityName
);

export enum NonEditableStandardEntityName {
  process = 'process',
  field = 'field',
}

export const nonEditableStandardEntityNames = Object.values(
  NonEditableStandardEntityName
);
export enum EditableFieldValuesEntityName {
  workTypes = IssueFieldNames.workTypes,
  hazardCategory = IssueFieldNames.hazardCategory,
  environmentalAspect = IssueFieldNames.environmentalAspect,
  proposedCorrectiveAction = IssueFieldNames.proposedCorrectiveAction,
  delayReason = IssueFieldNames.delayReason,
  issueVerificationItem = IssueFieldNames.issueVerification,
  rejectionReason = IssueFieldNames.rejectionReason,
  rootCauses = IssueFieldNames.rootCauses,
  effect = IssueFieldNames.effect,
  circumstances = IssueFieldNames.circumstances,
  impact = IssueFieldNames.impact,
  decisionToImposeFine = IssueFieldNames.decisionToImposeFine,
  spilledSubstance = IssueFieldNames.spilledSubstance,
  priority = IssueFieldNames.priority,
  projectStage = IssueFieldNames.projectStage,
  employmentType = IssueFieldNames.employmentType,
  injuryType = IssueFieldNames.injuryTypes,
  injuredBodyPart = IssueFieldNames.injuredBodyParts,
  requirements = IssueFieldNames.requirements,
  installationBasis = IssueFieldNames.installationBasis,
  constructionProductDocuments = IssueFieldNames.constructionProductDocuments,
  deviceDocuments = IssueFieldNames.deviceDocuments,
  additionalDocuments = IssueFieldNames.additionalDocuments,
}

export const editableFieldValuesEntityNames = Object.values(
  EditableFieldValuesEntityName
);

enum NonEditableFieldValuesEntityNames {
  solutionMethod = IssueFieldNames.solutionMethod,
}
export type EntityName =
  | EditableStandardEntityName
  | EditableFieldValuesEntityName
  | NonEditableFieldValuesEntityNames
  | NonEditableStandardEntityName;

export const nonEditableFieldValuesEntityNames = Object.values(
  NonEditableFieldValuesEntityNames
);

export type CreatableModelName = EditableFieldValuesEntityName;

export function toEntityName(value?: string): string | undefined {
  switch (value) {
    case IssueFieldNames.subcontractors:
    case IssueFieldNames.executedByCompanies:
      return EditableStandardEntityName.company;
    case IssueFieldNames.contractNumbers:
      return EditableStandardEntityName.contract;
    case IssueFieldNames.assignee:
    case IssueFieldNames.executor:
    case IssueFieldNames.supervisor:
      return EditableStandardEntityName.user;
    case IssueFieldNames.level:
      return EditableStandardEntityName.level;
    case IssueFieldNames.site:
      return EditableStandardEntityName.location;
    case IssueFieldNames.workTypes:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.workTypes;
    case IssueFieldNames.hazardCategory:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.hazardCategory;
    case IssueFieldNames.environmentalAspect:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.environmentalAspect;
    case IssueFieldNames.proposedCorrectiveAction:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.proposedCorrectiveAction;
    case IssueFieldNames.delayReason:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.delayReason;
    case IssueFieldNames.rejectionReason:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.rejectionReason;
    case IssueFieldNames.issueVerification:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.issueVerificationItem;
    case IssueFieldNames.rootCauses:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.rootCauses;
    case IssueFieldNames.effect:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.effect;
    case IssueFieldNames.circumstances:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.circumstances;
    case IssueFieldNames.impact:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.impact;
    case IssueFieldNames.decisionToImposeFine:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.decisionToImposeFine;
    case IssueFieldNames.spilledSubstance:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.spilledSubstance;
    case IssueFieldNames.priority:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.priority;
    case IssueFieldNames.projectStage:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.projectStage;
    case IssueFieldNames.employmentType:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.employmentType;
    case IssueFieldNames.injuryTypes:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.injuryType;
    case IssueFieldNames.injuredBodyParts:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.injuredBodyPart;
    case IssueFieldNames.requirements:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.requirements;
    case IssueFieldNames.installationBasis:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.installationBasis;
    case IssueFieldNames.constructionProductDocuments:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.constructionProductDocuments;
    case IssueFieldNames.deviceDocuments:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.deviceDocuments;
    case IssueFieldNames.additionalDocuments:
      // @ts-ignore TODO MUI5
      return EditableFieldValuesEntityName.additionalDocuments;

    default:
      return undefined;
  }
}
